import produce from 'immer';
import {
    CMS_CAROUSEL_SCROLL_DIRECTION,
    CMS_CAROUSEL_SCROLL_STEP,
    CMS_CLEAN_TRACKING_BANNERS,
    CMS_PUSH_TRACKING_BANNERS
} from '../actions/constants';

const initialState = {
    scrollDirection: '',
    scrollStep: 1,
    mainNavigation: null,
    currentNavigation: null,
    articles: [],
    v3: {
        revisionId: null,
        pageId: null,
        tracking: {
            banners: []
        }
    }
};

const CMSReducer = produce((state, action) => {
    const { type, payload } = action;

    switch (type) {
        case CMS_CAROUSEL_SCROLL_DIRECTION:
            state.scrollDirection = payload;
            break;

        case CMS_CAROUSEL_SCROLL_STEP:
            state.scrollStep = payload;
            break;

        case CMS_PUSH_TRACKING_BANNERS:
            state.v3.tracking.banners = [
                ...state.v3.tracking.banners,
                payload
            ];

            break;

        case CMS_CLEAN_TRACKING_BANNERS:
            state.v3.tracking.banners = [];
            break;

        // skip default
    }
}, initialState);

export default CMSReducer;
